import { useState } from 'react'
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { styled } from "@mui/material";

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme, color }) => ({
    border: `1px solid ${theme.palette[color].main}`,
    overflow:"hidden",
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  }));
  
  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.5rem' }} />}
      {...props}
    />
  ))(({ theme , color }) => ({
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : `${theme.functions.linearGradient(
          theme.functions.rgba(theme.palette.gradients[color].main, 1),
          theme.functions.rgba(theme.palette.gradients[color].state, 1)
          )}`,
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
  }));
  
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

const MDAccordion = ({children, color}) => {
    
    const [expanded, setExpanded] = useState('panel-0');
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
  /*eslint-disable*/
  return (
    children && children.length > 0 && children.map((child,index)=>(
    <Accordion color={color} sx={{borderRadius : index === 0 ? "10px 10px 0 0" : index === children.length - 1 ?  "0 0 10px 10px" : 0}}  key={`panel-${index}`} expanded={expanded === `panel-${index}`} onChange={handleChange(`panel-${index}`)}>
      <AccordionSummary color={color}>
        {child.props.children[0]}
      </AccordionSummary>
      <AccordionDetails>
        {child.props.children[1]}
      </AccordionDetails>
    </Accordion>
    ))
  )
}

export default MDAccordion